import { createSearchParams, generatePath } from 'react-router-dom';
import { locations } from 'services/routes/locations';

export const transformInstruments = (instruments: string[]) => {
  const instrumentsMap = instruments.reduce<Record<string, number>>(
    (acc, instrument) => {
      let instrumentCount = acc[instrument];
      if (!instrumentCount) {
        instrumentCount = 0;
      }
      return {
        ...acc,
        [instrument]: instrumentCount + 1,
      };
    },
    {}
  );

  const transformedInstruments = Object.entries(instrumentsMap).map((entry) =>
    entry.join(':')
  );

  return transformedInstruments;
};

type FormulaRecord = Record<string, string | number | null | string[]>;
type SearchParamsRecord = Record<string, string | string[]>;

const getFormulaUrl = (formula: FormulaRecord): string => {
  const processedParams = Object.entries(formula).reduce<SearchParamsRecord>(
    (acc, [key, value]) => {
      if (value === null) {
        return acc;
      }

      if (Array.isArray(value) && key === 'instruments') {
        return {
          ...acc,
          [key]: transformInstruments(value),
        };
      }

      return {
        ...acc,
        [key]: value.toString(),
      };
    },
    {}
  );

  const searchParams = createSearchParams({
    ...processedParams,
    autostart: '',
  });

  const path = generatePath(locations.general.aiMusicGenerator.pathname);
  const queryString = searchParams.toString();
  const url = `${path}?${queryString}`;

  return url;
};

export default getFormulaUrl;
